import styled from 'styled-components';

export namespace NavigationAppsBottomSheetCSS {
  export const Title = styled.div`
    padding: 0 ${({ theme }) => theme.spacing.s};
  `;

  export const Footer = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: ${({ theme }) => theme.spacing.xs};
    padding: ${({ theme }) => theme.spacing.xs} ${({ theme }) => theme.spacing.s};
    border-top: 1px solid ${({ theme }) => theme.colors.border.default};
  `;

  export const IconCard = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border: 1px solid ${({ theme }) => theme.colors.border.default};
    border-radius: 5px;
    background-color: ${({ theme }) => theme.colors.surface.default};
  `;
}
